<template>
  <div class="row">
    <div class="col-6 col-md-4 form-group" id="loan-details-amount" v-if="showFullDetailsForWrittenOff || !isWrittenOff">
      <div class="small text-muted-more">{{ $t('LoanDetailsPage.loanAmount') }}</div>
      <div class="text-amount small text-muted">{{ $n(loan.amount, 'currency') }}</div>
    </div>
    <div class="col-6 col-md-4 form-group" v-if="showEir && isNumber(loan.eir)" id="loan-details-eir">
      <div class="small text-muted-more">{{ $t('LoanDetailsPage.interestRate') }}</div>
      <div class="text-amount small text-muted">{{ $n(loan.eir, 'percent') }}%</div>
    </div>
    <div class="col-6 col-md-4 form-group" v-if="showApr && isNumber(loan.apr)" id="loan-details-apr">
      <div class="small text-muted-more">{{ $t('LoanDetailsPage.apr') }}</div>
      <div class="text-amount small text-muted">{{ $n(loan.apr, 'percent') }}%</div>
    </div>
    <div class="col-6 col-md-4 form-group" id="loan-payout-method" v-if="shouldDisplayPayoutMethod">
      <div class="small text-muted-more">{{ $t('LoanDetailsPage.payoutMethod') }}</div>
      <div class="text-amount small text-muted">{{ $t(`LoanDetailsPage.payoutMethods.${ loan.payoutMethod }`) }}</div>
    </div>
    <div class="col-6 col-md-4 form-group" id="loan-period">
      <div class="small text-muted-more">{{ $t('LoanDetailsPage.loanPeriod') }}</div>
      <strong class="small text-muted">{{ $tc('LoanDetailsPage.month', loan.periodInMonths) }}</strong>
    </div>
    <div class="col-6 col-md-4 form-group" id="loan-start">
      <div class="small text-muted-more">{{ $t('LoanDetailsPage.loanStart') }}</div>
      <strong class="small text-muted">{{ $d(loan.contractDate) }}</strong>
    </div>
    <div class="col-6 col-md-4 form-group" id="loan-end">
      <div class="small text-muted-more">{{ $t('LoanDetailsPage.loanEnd') }}</div>
      <strong class="small text-muted">{{ $d(endDate) }}</strong>
    </div>
  </div>
</template>
<script>

export default {
  name: 'LoanGeneralDetails',
  props: ['loan', 'showFullDetailsForWrittenOff', 'showEir', 'showApr'],
  methods: {
    isNumber(value) {
      return (value || value === 0) && !Number.isNaN(value)
    }
  },
  computed: {
    isClosed() {
      return this.loan.status === 'CLOSED'
    },
    endDate() {
      return this.isClosed ? this.loan.closeDate : this.loan.endDate
    },
    isWrittenOff() {
      return this.loan.status === 'DEFAULTED' && this.loan.subStatus === 'WRITTEN_OFF'
    },
    shouldDisplayPayoutMethod() {
      return !this.$configuration.newCoreEnabled
    }
  }
}
</script>
